import EmptyState from '@components/EmptyState'
import React from 'react'

const ScheduleOrientation: React.FC = () => (
  <EmptyState
    heading="Before we book your lessons let's organize your Getting Started or Orientation session."
    img="/images/lost.svg"
    bodyTxt="Once this has been booked you can come back and book your lessons."
    linkUrl="/support/contact-us/?id=technical-support"
    btnTxt="Schedule orientation"
    top="md"
    bottom="xxxl"
  />
)

export default ScheduleOrientation
